/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
    .controller('CheckoutOrderReviewBoxController', function ($scope, $q, $element, ControlService) {
        $scope.Model = $scope.Model || {};
        $scope.Control = $scope.Control || {};

        $scope.Control.deliveryPointExists = function(code) {
            if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.DeliveryPoint) {

                var currentOrderScope = $scope['Order'].Current;
                if (currentOrderScope.DeliveryPoint.Code === code) {

                    var deliveryPointsElement = angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint');
                    if (deliveryPointsElement.length > 0) {
                        var $dpScope = deliveryPointsElement.scope();
                        var deliveryPoints = $dpScope.Model.Data.DeliveryPoints || [];

                        var resolved = _.find(deliveryPoints, function (dp) { return dp.Code == code; });
                        return (resolved !== undefined);

                    } else {
                        return true;
                    }

                }
            }

            return false;
        };

        var orderScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

        $scope.Control.getShippingCountryName = function (code) {
            var country = _.first(_.filter(orderScope.Model.Data.ShippingCountries, function (x) { return x.Code === code; }));
            return country ? country.Name : country;
        };

        $scope.Control.getBillingCountryName = function (code) {
            var country = _.first(_.filter(orderScope.Model.Data.BillingCountries, function (x) { return x.Code === code; }));
            return country ? country.Name : country;
        };

        $scope.Control.getCountryName = function (code) {
            var country = _.first(_.filter(orderScope.Model.Data.Countries, function (x) { return x.Code === code; }));
            return country ? country.Name : country;
        };

        $scope.Control.IsBillingFieldVisible = function (field) {
            return $scope.Order.Current.Config['IsBilling' + field + 'Visible'];
        }

        //implementation for dropdowns in review step
        $scope.$on('updateReviewBoxAddresses', function () {
            //console.log('need to reload');
            $element.get(0).reload();
        });
        $scope.Control.Highlight = function (selector, timeout) {
            var item = $(selector, $element);
            if (item.offset().top - 50 > $(window).scrollTop() + $(window).height()) {
                $('html,body').animate({ scrollTop: $(selector, $element).offset().top - 100 }, 200);
            }
            $(selector, $element).addClass('highlighted');
            setTimeout(function () {
                $(selector, $element).removeClass('highlighted');
            }, timeout);
        }

        $scope.Control.dot2comma = function (value) {
            return (value) ? value.toString().trim().replace(".", ",") : null;
        };

        var defered = $q.defer();
        ControlService.getCheckoutData("GetOrderReviewBoxData", $scope, $element).then(function (response) {
            angular.extend($scope.Model, response);
            $scope.Control.ShippingAddresses = $scope.ShippingAddresses;
            $scope.Control.BillingAddresses = $scope.BillingAddresses;
            defered.resolve();
            $('.x-checkoutorderreviewbox .angular-control-loading').addClass('ng-hide').hide();
        }, function (error) {    
            throw error;
        });

        $element.get(0).reload = function () {
            $scope.Control.ShippingAddresses = $scope.ShippingAddresses;
            $scope.Control.BillingAddresses = $scope.BillingAddresses;
            defered.resolve();
            $('.x-checkoutorderreviewbox .angular-control-loading').addClass('ng-hide').hide();
        };

        $scope.$watch('Order.Current.PickupPoint',
            function(newValue, prevValue) {
                if (!newValue)
                    return;

                $scope.Control.PickupPointData = {};
                $scope.Control.PickupPointData[$scope.Order.Current.PickupPoint.CompanyCode] = JSON.parse($scope.Order.Current.PickupPoint.Data).location;
            });
    });
})();